const enUSJson = {
  common: {
    add: "Add",
    edit: "Edit",
    view: "View",
    update: "Update",
    delete: "Delete",
    actions: "Actions",
    apply: "Apply",
    reset: "Reset",
    menu: "Menu",
    search: "Search",
    noSearchResults: "No results found",
    noDataAvailable: "No Data Available",
    loadingText: "We are loading the data for you. Please wait.",
    cancel: "Cancel",
    select: "Select",
    close: "Close",
    save: "Save",
    saveSuccess: "{{name}} saved successfully.",
    yes: 'Yes',
    no: 'No',
    expand: "Expand",
    collapse: "Collapse",
    downloadPDF: "Download as PDF",
    downloadCSV: "Download as CSV",
    downloadExcel: "Download as Excel",
    tips: {
      downloadFailed: "Download failed."
    },
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
      jsonError: 'Incorrect JSON format. Please enter the correct JSON format.'
    },
    jsonLabel: 'JSON',
    next: "Next",
    disable: "Disable",
    enable: "Enable",
    editable: "Editable",
    readOnly: "Read Only",
    status: "Status",
    type: "Type",
    mandatory: "Mandatory",
    selectAll: "Select All",
    pleaseSelect: "Please select",
  },
  validation: {
    isRequired: "is required",
    regexErrorTip: 'Please enter a valid format',
    numberTooSmallTip: 'The value must be at least {{number}}',
    numberTooBigTip: 'The value must be at most {{number}}',
    numberIntegerOnly: 'Integer only',
    numberMaxDecimalPlaces: "No more than {{number}} decimal places",
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}'
  },
  menu: {
    eventLibrary: "Event Library",
    timelineTemplate: "Timeline Template",
    eventManager: "Event Manager",
  },
  eventLibrary: {
    eventLibrary: 'Event',
    eventTemplate: 'Event Template',
    eventID: 'Event ID',
    eventName: 'Event Name',
    fieldName: 'Field Name',
    module: 'Module',
    eventCategory: 'Event Category',
    description: 'Description',
    businessTypeID: "Primary Business Object Type ID",
    isMilestone: 'Mark as milestone',
    createEvent: 'Create New Event Template',
    userDefinedFields: 'User Defined Fields',
    optional: 'Optional',
    addField: 'Add Field',
    eventIdTip: 'Event ID will be automatically generated upon creation',
    autoGenerated: 'Auto-generated',
    duplicateFieldName: 'Duplicate event field name. Please choose a different name.',
    duplicateBusinessPrimaryType: 'Module with the same primary business object type ID already exists.',
    fieldValue: 'Field Value',
    businessPrimaryObject: "Primary Business Object",
    addSuccessTip: 'Template added successfully.',
    updateSuccessTip: 'Template updated successfully.'
  }
};

export default enUSJson;
